import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getCompany, updateCompany } from '../../actions/companies-actions';
import { provinces } from '../../actions/global-actions-data';

function EditCompany(){
    const currentLink = "/aseguradoras";
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loadData, setLoadData] = useState(true);
    const params = useParams();
    const user = useSelector(state => state.user.user);

    const [form, setForm] = useState({
        description: '',
        email: '',
        city: '',
        province: ''
    });

    const [citiesData, setCitiesData] = useState({
        showCities: false,
        cities: []
    });

    useEffect(() => {
        if (loadData) {
            const getFunction = (data) => {
                if(data.code === "01"){
                    Swal.fire({
                        title:"Error",
                        confirmButtonColor:"#76b4ff",
                        text: data.message
                    });
                }else{
                    //console.log(data.data);
                    const cities = provinces.find( x => x.name === data.data[0].province).cities;            
                    setCitiesData({
                        showCities: true,
                        cities
                    })
                    setForm({
                        ...form,
                        ...data.data[0]
                    })
                }
            }

            setLoadData(false);
            setForm({
                description: '',
                email: '',
                city: '',
                province: ''
            });
            dispatch( getCompany( params.id, getFunction, user.token ) );
        }
    }, [loadData, dispatch, params.id, form, user.token ]);


    useEffect(() => {
        //console.log(form);
    }, [form]);

    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    const handleOnChange = (event) => {
        const value = event.target.value;
        if (value !== '' && value) {
            const cities = provinces.find( x => x.name === value).cities;            
            setCitiesData({
                showCities: true,
                cities
            })
            setForm({
                ...form,
                [event.target.name]: event.target.value
            })
        } else {
            setCitiesData({
                showCities: false,
                cities: []
            })
            setForm({
                ...form,
                city :  '',
                province: ''
            })
        }
    }

    const handleOnSubmit = (event) => {
        event.preventDefault();
        const isEmpty = Object.values(form).some(x => x === null || x === '');
        if (isEmpty) {
            Swal.fire({
                title:"Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar todos los datos para continuar"
            });
            return;
        } else {
            dispatch( updateCompany ( form, updateFunction, user.token ) );
        }
    }

    const updateFunction = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            navigate(currentLink);
            //console.log(data);
            Swal.fire({
                title:"¡Éxito!",
                confirmButtonColor:"#76b4ff",
                text: "Aseguradora actualizada con éxito"
            });
        }
    }

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={currentLink} className="back-button">&#60; Volver</Link>
                </div>
                <h1 className="my-5">Editar aseguradora</h1>
                <form onSubmit={handleOnSubmit}>
                    <div className="d-flex w-100 flex-wrap">
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="description">Nombre</label>
                            <input id="description" name="description" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleInputChange} value={form.description}></input>
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="email">Email</label>
                            <input id="email" name="email" autoComplete="off" maxLength={120} className="input-field" type="email" onChange={handleInputChange} value={form.email}></input>
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="province">Departamento</label>
                            <select className="input-field" id="province" name="province" onChange={handleOnChange} value={form.province}>
                                <option></option>
                                {provinces.map((province, index) => (
                                    <option key={index} value={province.name}>{province.name}</option>
                                ))}
                            </select>
                        </div>
                        {citiesData.showCities && citiesData.cities !== []? 
                            <div className="d-flex flex-column w-50 field">
                                <label className="label-field" htmlFor="city">Ciudad</label>
                                <select className="input-field" id="city" name="city" onChange={handleInputChange} value={form.city}>
                                    <option></option>
                                    {citiesData.cities.map((city) => (
                                        <option key={city.name} value={city.name}>{city.name}</option>
                                    ))}
                                </select>
                            </div>
                            :''}
                        <div className="w-100 d-flex d-flex justify-content-center my-4">
                            <button className="primary-button save-button" type="submit">Guardar &#43;</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default EditCompany;
  